import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";

export default function PublicRouter() {
    const isAuthenticated = Cookies.get('token');
    const hasSessionId = sessionStorage.getItem('mid');

    // Allow secret admin direct login route even if already authenticated
    if (typeof window !== "undefined") {
        const href = window.location.href || "";
        if (href.includes("sys-adm-9x7q")) {
            return <Outlet />;
        }
    }

    if (isAuthenticated && hasSessionId) {
        return <Navigate to="/dashboard" />;
    } else {
        return <Outlet />;
    }
}

// export default function PublicRouter() {
//     if (Cookies.get("token")) {
//         return <Navigate to="/dashboard" />;
//     } else {
//         return <Outlet />;
//     }
// }

// const PublicRoute = () => {
//     const { user, loading } = useAuth();

//     if (loading) return <Loader />;

//     if (user?.token) return <Navigate to="/dashboard" replace />;

//     return <Outlet />;
// };

// export default PublicRoute;